export default "__VITE_ASSET__1cf8971f__"